import { styled } from '@mui/material';

export const AttachmentsCount = styled('header')(({ theme }) => ({
  '& > .MuiTypography-root': {
    fontWeight: 'var(--font-weight-text-caption)',
  },
  color: theme.palette.primary.main,
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--spacing-tiny)',
  padding: 'var(--spacing-medium) var(--spacing-medium) 0',
}));
